export const SET_CITY = 'SET_CITY';
export const SET_DATE_START = 'SET_DATE_START';
export const SET_DATE_END = 'SET_DATE_END';
export const SET_ADULTS = 'SET_ADULTS';
export const SET_CHILDREN = 'SET_CHILDREN';
export const SET_HOTEL = 'SET_HOTEL';
export const SET_FORM_VALUES_BY_PARAMS = 'SET_FORM_VALUES_BY_PARAMS';
export const RESET_DESTINATIONS = 'RESET_DESTINATIONS';
export const RESET_PARTICIPANTS = 'RESET_PARTICIPANTS';

export const setCity = (city) => ({
    type: SET_CITY,
    payload: city
})
export const setDateStart = (dateStart) => ({
    type: SET_DATE_START,
    payload: dateStart
})
export const setDateEnd = (dateEnd) => ({
    type: SET_DATE_END,
    payload: dateEnd
})
export const setAdults = (adults) => ({
    type: SET_ADULTS,
    payload: adults
})
export const setChildren = (children) => ({
    type: SET_CHILDREN,
    payload: children
})
export const setHotel = (hotel) => ({
    type: SET_HOTEL,
    payload: hotel
})
export const setFormValuesByParams = (key, value) => ({
    type: SET_FORM_VALUES_BY_PARAMS,
    payload: { key, value }
})
export const resetDestinations = () => ({
    type: 'RESET_DESTINATIONS',
})
export const resetParticipants = () => ({
    type: RESET_PARTICIPANTS,
})